import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=5183ed4a&scoped=true&"
import script from "./Aside.vue?vue&type=script&lang=js&"
export * from "./Aside.vue?vue&type=script&lang=js&"
import style0 from "./Aside.vue?vue&type=style&index=0&id=5183ed4a&lang=scss&scoped=true&"
import style1 from "./Aside.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5183ed4a",
  null
  
)

export default component.exports